// extracted by mini-css-extract-plugin
export default {"crsstk":"CoursePage_crsstk__e1lv3","txhd":"CoursePage_txhd__uJSBt","txcr":"CoursePage_txcr__YWjov","txmh":"CoursePage_txmh__EU3Gg"};